import { CmsConfirmDialog } from "../CmsConfirmDialog/CmsConfirmDialog";
import styles from "./UnscoredQuestionsModal.module.css";

type UnscoredQuestionsModalProps = {
  missingLabels: string[];
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Asks whether to save a card that still has unscored questions, names them, and warns that
 * confirming will store a zero for each one.
 *
 * It runs before the save, not after it, so it must not claim anything has been written — the
 * researcher decides here. Confirming saves the card as it stands, with the questions below
 * recorded as zero; cancelling writes nothing and returns them to the card with their edits
 * intact.
 *
 * `warning`: nothing is lost either way, there are just questions still to answer.
 */
export function UnscoredQuestionsModal({
  missingLabels,
  onConfirm,
  onCancel,
}: UnscoredQuestionsModalProps) {
  return (
    <CmsConfirmDialog
      title="Some SAR questions are still unscored"
      message="These questions still need a score. If you save now, they will be saved as zero:"
      detail={
        <ul className={styles.missingList}>
          {missingLabels.map(label => (
            <li key={label}>{label}</li>
          ))}
        </ul>
      }
      confirmLabel="Save anyway"
      cancelLabel="Cancel"
      tone="warning"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
